import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Message } from 'primeng/primeng';
import { OpeningStationService } from '../../../service/opening-station/opening-station.service';
import { OpeningStation } from '../../../class/opening-station';

@Component({
  selector: 'app-opening-station',
  templateUrl: './opening-station.component.html',
  styleUrls: ['./opening-station.component.scss']
})
export class OpeningStationComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() infoOpeningStation: OpeningStation;
    public openingStation: OpeningStation;
    public msgs: Message[] = [];
    public options: any;

    constructor(
        public openingStationService: OpeningStationService,
        private activatedRoute: ActivatedRoute) {
    }

    ngOnInit() {
    }

    public cancelOpeningStation () {
        this.close.emit(true);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/opening-stations/opening-station/opening-station.component.ts